import $ from 'jquery';
import TeaserViewTracker from '../tracking/google/360/teaser_view_tracker';
import 'utils/sliderknobs.js';
import 'utils/slidercontrols.js';
import 'utils/sliderlazyload.js';
import 'swipe';

export default function LeadTeaser() {
  this.callbackFunction = function (index, element) {
    var teaserImpressionCallback = new TeaserViewTracker().getSwipeCallbackFunction();
    teaserImpressionCallback(index, element);
    var parent = $(element).closest(".js-teasertracking");
    if (parent) {
      $(parent).attr("data-current-slide", index);
    }
  };
}

LeadTeaser.prototype.removeSwipes = function () {
  $(".lead-teaser.swipe").each(function () {
    if ($(this).data("Swipe")) {
      $(this).data("Swipe").kill();
      $(this).find(".swipe-clone").remove();
    }
  });
};

LeadTeaser.prototype.responsive = function (msg, on_off) {
  switch (msg) {
    case 'res.xs':
      if (on_off) { // entered state xs
        this.removeSwipes();
        $(".lead-teaser.swipe").each(function () {
          var swipe = $(this);
          var numberOfCols = 2;
          fillLastSlide(swipe.find(".lead"), numberOfCols);
          swipe.Swipe({pair: numberOfCols, callback: this.callbackFunction}).knobs().lazy();
        });
      }
      break;
    case 'res.sm':
      if (on_off) { // entered state sm
        this.removeSwipes();
        $(".lead-teaser.swipe").each(function () {
          var swipe = $(this);
          var numberOfCols = 2;
          fillLastSlide(swipe.find(".lead"), numberOfCols);
          swipe.Swipe({pair: numberOfCols, callback: this.callbackFunction}).knobs().lazy();
        });
      }
      break;
    default:
      if (on_off) {
        this.removeSwipes();
        $(".lead-teaser.swipe").each(function () {
          var swipe = $(this);
          var numberOfCols = 4;
          fillLastSlide(swipe.find(".lead"), numberOfCols);
          swipe.Swipe({pair: 4, continuous: false, callback: this.callbackFunction}).lazy();
        });
      }
  }
};

function fillLastSlide(swipeItems, numberOfCols) {
  var numberOfItems = swipeItems.length;
  var numberOfSurplusItems = numberOfItems % numberOfCols;
  if (numberOfItems > numberOfCols && numberOfSurplusItems !== 0) {
    var idOfInsertBefore = numberOfItems - numberOfSurplusItems;
    var insertBefore = $(swipeItems[idOfInsertBefore]);
    for (var id = (idOfInsertBefore - 1); id >= (idOfInsertBefore - (numberOfCols - numberOfSurplusItems)); id--) {
      var clone = $(swipeItems[id]).clone().addClass("swipe-clone");
      insertBefore.before(clone);
      insertBefore = clone;
    }
  }
}

LeadTeaser.prototype.init = function () {
  $(document).ready(function () {
    $(".js-lead-video").on('click', function () {
      $("body").append("<div class='modal-backdrop in'></div>");
    });

    $('.modal.tutorial-video').on('hide.bs.modal', function (e) {
      $(".modal-backdrop").remove();
    });
  });
};


